// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Table } from 'react-bootstrap';
// import { useSelector, useDispatch } from 'react-redux';
// import apiFc from '../../services/APIFc';
// import { Box } from '@mui/material';
// import SliderMui from "@mui/material/Slider";
// import { setPedidosSeguimientoCancelado, setPedidosDespachados, actualizarPedidos, actualizarPedidosDespachados } from '../../redux/actions/pedido';

// const ModalPedidoInicio = ({
//   basic,
//   setBasic,
//   transportesDisponibles,
//   puntosRecorrido,
//   actualizarPuntosRecorrido,
//   setSliderValue,
//   imagenEstadoPedido
// }: {
//   basic: boolean;
//   setBasic: React.Dispatch<React.SetStateAction<boolean>>;
//   transportesDisponibles: any[];
//   puntosRecorrido: any;
//   actualizarPuntosRecorrido: (pedidoNroMovVta: string, newValue: number) => void;
//   setSliderValue: React.Dispatch<React.SetStateAction<number>>;
//   imagenEstadoPedido: (idEstado: number) => string;
// }) => {
//   const dispatch = useDispatch();
//   const [pedidos, setPedidos] = useState<any[]>([]);
//   const pedidosDespachados = useSelector((state: any) => state.pedidosDespachados || []);
//   const pedidosSeguimientoCancelado = useSelector((state: any) => state.pedidosSeguimientoCancelado || []);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowWidth(window.innerWidth);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     const pedidosCancelados = JSON.parse(localStorage.getItem('pedidosSeguimientoCancelado') || '[]');
//     if (pedidosCancelados.length > 0) {
//       pedidosCancelados.forEach((pedidoNroMovVta: string) => {
//         dispatch(setPedidosSeguimientoCancelado(pedidoNroMovVta));
//       });
//     }
//   }, [dispatch]);

//   const obtenerPedidos = () => {
//     apiFc.get('/web/pedido/pedidos/historico?page=0&rows=10')
//       .then(res => {
//         const pedidosObtenidos = res.data.content;
//         dispatch(actualizarPedidos(pedidosObtenidos));

//         const pedidosCancelados = JSON.parse(localStorage.getItem('pedidosSeguimientoCancelado') || '[]');

//         const pedidosFiltrados = pedidosObtenidos.filter((pedido: any) => {
//           const isCancelled = pedidosCancelados.includes(pedido.pedidoNroMovVta);
//           const hasEstado = pedido.pedidoEstado;
//           const isEstadoExcluded = hasEstado && [2, 50, 20, 21, 22, -70, -101, -102].includes(pedido.pedidoEstado.pedidoEstadoId);
//           return !isCancelled && hasEstado && !isEstadoExcluded;
//         });

//         setPedidos(pedidosFiltrados);

//       })
//       .catch(error => {
//         console.log("Error");
//       });
//   };

//   useEffect(() => {
//     if (basic) {
//       obtenerPedidos();
//     }
//   }, [basic]);

//   const handleRecibirPedido = (pedidoNroMovVta: any): void => {
//     apiFc.post(`/web/pedido/pedidos/recibir?nmv=${pedidoNroMovVta}`, {})
//       .then(() => {
//         dispatch(actualizarPedidosDespachados(pedidosDespachados));
//         obtenerPedidos();
//       })
//       .catch(res => {
//         console.log("Error");
//       });
//   };

//   const handleDejarDeSeguir = (pedidoNroMovVta: string) => {
//     // guardo en Redux
//     dispatch(setPedidosSeguimientoCancelado(pedidoNroMovVta));
//     // guardo en localStorage
//     const pedidosCancelados = JSON.parse(localStorage.getItem('pedidosSeguimientoCancelado') || '[]');
//     pedidosCancelados.push(pedidoNroMovVta);
//     localStorage.setItem('pedidosSeguimientoCancelado', JSON.stringify(pedidosCancelados));
//     // actualizo pedidos despachados
//     const nuevosPedidosDespachados = pedidosDespachados.filter((pedido: any) => pedido.pedidoNroMovVta !== pedidoNroMovVta);
//     dispatch(actualizarPedidosDespachados(nuevosPedidosDespachados));
//     // actualizo localmente
//     setPedidos(prevPedidos => prevPedidos.filter(pedido => pedido.pedidoNroMovVta !== pedidoNroMovVta));
//   };

//   const handleClose = () => {
//     setBasic(false);
//   };

//   const marksrv = [
//     { value: 0, id: 1, label: "Enviado" },
//     { value: 2, id: 2, label: "Recibido" },
//     { value: 4, id: 3, label: "Demorado" },
//     { value: 6, id: 4, label: "Procesando" },
//     { value: 8, id: 5, label: "Embalado" },
//     { value: 10, id: 6, label: "Facturado" },
//     { value: 12, id: 10, label: "Despachado" },
//   ];

//   const mobileMarksrv = [
//     { value: 0, id: 1, label: "Enviado" },
//     { value: 6, id: 4, label: "Procesando" },
//     { value: 12, id: 10, label: "Despachado" },
//   ];

//   const pedidosFiltrados = pedidos.filter(pedido => {
//     const isCancelled = pedidosSeguimientoCancelado.includes(pedido.pedidoNroMovVta);
//     const hasEstado = pedido.pedidoEstado;
//     const isEstadoExcluded = hasEstado && [2, 50, 20, 21, 22, -70, -101, -102].includes(pedido.pedidoEstado.pedidoEstadoId);
//     return !isCancelled && hasEstado && !isEstadoExcluded;
//   });

//   if (!basic || pedidosFiltrados.length === 0) {
//     return null;
//   }

//   const puntosAMostrar = windowWidth < 1000 ? 3 : Object.keys(puntosRecorrido).length;

//   interface RangeSlider2Props {
//     value: number[];
//     onChange: (newValue: number) => void;
//     pedidoEstadoId: number;
//   }

//   const RangeSlider2: React.FC<RangeSlider2Props> = ({ value, onChange, pedidoEstadoId }) => {
//     const valuetext2 = (value: number) => {
//       const selectedMark = windowWidth < 1000 ? mobileMarksrv.find(mark => mark.value === value) : marksrv.find(mark => mark.value === value);
//       return selectedMark ? selectedMark.label : '';
//     };

//     const markValue = marksrv.find(mark => mark.id === pedidoEstadoId)?.value || 0;
//     const puntosRecorrido = windowWidth < 1000 ? mobileMarksrv : marksrv;

//     return (
//       <Box className="wd-90p d-flex m-auto">
//         <SliderMui
//           aria-label="Restricted values"
//           max={12}
//           value={[markValue]}
//           valueLabelFormat={valuetext2}
//           getAriaValueText={valuetext2}
//           step={null}
//           valueLabelDisplay="auto"
//           marks={puntosRecorrido}
//           track="inverted"
//           onChange={(event, newValue) => {
//             const selectedMark = puntosRecorrido.find(mark => mark.value === newValue);
//             if (selectedMark) {
//               onChange(selectedMark.id);
//             }
//           }}
//         />
//       </Box>
//     );
//   };

//   return (

//     <Modal show={basic && pedidosFiltrados.length > 0} onHide={handleClose} size="lg">
//       <Modal.Header closeButton>
//         <Modal.Title>Envío de Pedido</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {pedidosFiltrados.length === 0 ? (
//           <p>No hay pedidos para mostrar.</p>
//         ) : (
//           <Table className="table mg-b-0 text-md-nowrap">
//             <thead>
//               <tr>
//                 <th>Pedidos</th>
//               </tr>
//             </thead>
//             <tbody>
//               {pedidosFiltrados.map((pedido: any) => (
//                 <tr key={pedido.pedidoNroMovVta} className="mb-3">
//                   <td>
//                     <strong>Fecha pedido:</strong> {new Date(pedido.pedidoFecha).toLocaleDateString('es-ES')}
//                     <br />
//                     <strong>NMV:</strong> {pedido.pedidoNroMovVta}
//                     <br />
//                     <strong>Transporte:</strong> {
//                       Array.isArray(transportesDisponibles) && transportesDisponibles.find(
//                         (transporte: any) => transporte.transporteID == pedido.transportePedidoID
//                       )?.transporteNombre || pedido.transportePedidoID
//                     }
//                     <br />
//                     <img
//                       src={require(`../../assets/img/pedido/${imagenEstadoPedido(pedido?.pedidoEstado?.pedidoEstadoId)}`)}
//                       alt=""
//                       width="32"
//                       height="32"
//                       className="br-2"
//                     />
//                      <RangeSlider2
//                       value={[puntosRecorrido[pedido.pedidoNroMovVta]]}
//                       onChange={(newValue:any) => {
//                         actualizarPuntosRecorrido(pedido.pedidoNroMovVta, newValue);
//                         setSliderValue(newValue);
//                       }}
//                       pedidoEstadoId={pedido.pedidoEstado.pedidoEstadoId}
//                     />
//                     <br />
//                     <div className="text-center mt-3">
//                       {pedido.pedidoEstado.pedidoEstadoId === 10 && (
//                         <Button variant="primary" className="mg-r-10" onClick={() => handleRecibirPedido(pedido.pedidoNroMovVta)}>
//                           Confirmar Recepción
//                         </Button>
//                       )}
//                       {pedido.pedidoEstado.pedidoEstadoId !== 10 && (
//                         <Button variant="primary" onClick={() => handleDejarDeSeguir(pedido.pedidoNroMovVta)}>Dejar de Seguir</Button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         )}
//         <div className="text-center mt-3">
//           <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default ModalPedidoInicio;


//a partir de aca tengo el nuevo "modal", seria la forma en la que muestro los pedidos a los clientes actualmente sin que se dispare siempre el viejo modal
//conservo el modal de arriba por si a caso se decide volver a lo mismo o se tiene que realizar un ejemplo de algo similar

import React, { useEffect, useMemo, useRef, useState } from "react";
import {Button, Card, Col, Row, Accordion } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import apiFc from "../../services/APIFc";
import {setPedidosSeguimientoCancelado, actualizarPedidosDespachados,} from "../../redux/actions/pedido";

const ModalPedidoInicio = React.memo(({
  basic,
  setBasic,
  transportesDisponibles,
  puntosRecorrido,
  actualizarPuntosRecorrido,
  setSliderValue,
  imagenEstadoPedido,
}: {
  basic: boolean;
  setBasic: React.Dispatch<React.SetStateAction<boolean>>;
  transportesDisponibles: any[];
  puntosRecorrido: any;
  actualizarPuntosRecorrido: (
    pedidoNroMovVta: string,
    newValue: number
  ) => void;
  setSliderValue: React.Dispatch<React.SetStateAction<number>>;
  imagenEstadoPedido: (idEstado: number) => string;
}) => {
  const dispatch = useDispatch();
  const [pedidos, setPedidos] = useState<any[]>([]);
  const pedidosDespachadosRaw = useSelector((state: any) => state.pedidosDespachados);
  const pedidosSeguimientoCanceladoRaw = useSelector((state: any) => state.pedidosSeguimientoCancelado);
  const pedidosDespachados = useMemo(() => pedidosDespachadosRaw || [], [pedidosDespachadosRaw]);
  const pedidosSeguimientoCancelado = useMemo(() => pedidosSeguimientoCanceladoRaw || [], [pedidosSeguimientoCanceladoRaw]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const pedidosCancelados = JSON.parse(
      localStorage.getItem("pedidosSeguimientoCancelado") || "[]"
    );
    if (pedidosCancelados.length > 0) {
      pedidosCancelados.forEach((pedidoNroMovVta: string) => {
        dispatch(setPedidosSeguimientoCancelado(pedidoNroMovVta));
      });
    }
  }, [dispatch]);

  const obtenerPedidos = () => {
    // 1. Obtener pedidos históricos
    apiFc.get("/web/pedido/pedidos/historico?page=0&rows=10")
      .then(historicoResponse => {
        const pedidosHistoricos = historicoResponse.data.content;
  
        // 2. Obtener pedidos despachados (usando Redux si ya existen)
        const pedidosDespachadosPromise = pedidosDespachados.length > 0 
          ? Promise.resolve(pedidosDespachados)
          : apiFc.get("/web/pedido/pedidos/despachados")
              .then(despachadosResponse => {
                const data = despachadosResponse.data.content || despachadosResponse.data;
                dispatch(actualizarPedidosDespachados(data));
                return data;
              });
  
        return Promise.all([pedidosHistoricos, pedidosDespachadosPromise]);
      })
      .then(([historicos, despachados]) => {
        // 3. Combinar y eliminar duplicados
        const pedidosCombinados = [...historicos, ...despachados]
          .filter((pedido, index, self) => 
            index === self.findIndex(p => p.pedidoNroMovVta === pedido.pedidoNroMovVta)
          );
  
        // 4. Aplicar filtros
        const pedidosCancelados = JSON.parse(
          localStorage.getItem("pedidosSeguimientoCancelado") || "[]"
        );
  
        setPedidos(pedidosCombinados.filter(pedido => 
          !pedidosCancelados.includes(pedido.pedidoNroMovVta) &&
          pedido.pedidoEstado &&
          ![2, 50, 20, 21, 22, -70, -101, -102].includes(pedido.pedidoEstado.pedidoEstadoId)
        ));
      })
      .catch(error => {
        console.error("Error al obtener pedidos:", error);
      });
  };
  
  const pedidosFiltrados = pedidos.filter((pedido) => {
    const isCancelled = pedidosSeguimientoCancelado.includes(
      pedido.pedidoNroMovVta
    );
    const hasEstado = pedido.pedidoEstado;
    const isEstadoExcluded =
      hasEstado &&
      [2, 50, 20, 21, 22, -70, -101, -102].includes(
        pedido.pedidoEstado.pedidoEstadoId
      );
    return !isCancelled && hasEstado && !isEstadoExcluded;
  });

  useEffect(() => {
    if (basic) {
      obtenerPedidos();
    }
  }, [basic]);

  const handleRecibirPedido = (pedidoNroMovVta: any): void => {
    apiFc
      .post(`/web/pedido/pedidos/recibir?nmv=${pedidoNroMovVta}`, {})
      .then(() => {
        dispatch(actualizarPedidosDespachados(pedidosDespachados));
        obtenerPedidos();
      })
      .catch((res) => {
        ("Error");
      });
  };




  const accordionRef = useRef<HTMLDivElement>(null);

  const handleDejarDeSeguir = (pedidoNroMovVta: string) => {
    dispatch(setPedidosSeguimientoCancelado(pedidoNroMovVta));
    const pedidosCancelados = JSON.parse(
      localStorage.getItem("pedidosSeguimientoCancelado") || "[]"
    );
    pedidosCancelados.push(pedidoNroMovVta);
    localStorage.setItem(
      "pedidosSeguimientoCancelado",
      JSON.stringify(pedidosCancelados)
    );
    const nuevosPedidosDespachados = pedidosDespachados.filter(
      (pedido: any) => pedido.pedidoNroMovVta !== pedidoNroMovVta
    );
    dispatch(actualizarPedidosDespachados(nuevosPedidosDespachados));
    setPedidos((prevPedidos) =>
      prevPedidos.filter((pedido) => pedido.pedidoNroMovVta !== pedidoNroMovVta)
    );
  };

    // const handleDejarDeSeguir = (pedidoNroMovVta: string) => {
    //   const pedidosActuales = [...pedidosSeguimientoCancelado];
    //   if (!pedidosActuales.includes(pedidoNroMovVta)) {
    //     pedidosActuales.push(pedidoNroMovVta);
    //     dispatch(setPedidosSeguimientoCancelado(pedidosActuales));
    //   } else {
    //     console.log("error");
    //   }
    //   // setPedidoAEliminar(pedidoNroMovVta);
    //   const nuevosPedidosDespachados = pedidosDespachados.filter((pedido: any) => pedido.pedidoNroMovVta !== pedidoNroMovVta);
    //   dispatch(setPedidosDespachados(nuevosPedidosDespachados));
    // };

  useEffect(() => {
    if (accordionRef.current) {
      // 2. Ahora TypeScript sabe que `current` es un HTMLDivElement
      const accordionButton = accordionRef.current.querySelector(".accordion-button");
      if (accordionButton && pedidosFiltrados.some(pedido => pedido.pedidoEstado.pedidoEstadoId === 10)) {
        // 3. Modifica los estilos del botón
        (accordionButton as HTMLElement).style.borderRadius = "0";
        (accordionButton as HTMLElement).style.backgroundColor = "#f34343";
      }
    }
  }, [pedidosFiltrados]);
  

  if (!basic || pedidosFiltrados.length === 0) {
    return null;
  }
  return (
    <div className="wd-100p">
      
     {/* {!isUserLogued && (*/}
  <Col lg={12} md={12}>
    <Card>
      {/* <Card.Body> */}
      {/* <div>
      <h6 className="card-title mb-1">Tus pedidos</h6>
    </div> */}
     <Accordion ref={accordionRef}>
        <Accordion.Item eventKey="0">
        <Accordion.Header className="d-flex align-items-center">
          {pedidosFiltrados.some(pedido => pedido.pedidoEstado.pedidoEstadoId === 10) ? (
            <div className="fade alert fade show alert-dismissible alert-solid-danger alert show py-1 mb-0 d-flex align-items-center">
              <strong className="me-2">Tus Pedidos:</strong>
              <span>Por favor, confirmá la recepción de tu pedido para que podamos asegurarnos de su correcta entrega, ¡muchas gracias!</span>
            </div>
          ) : (
            <span className="pe-2">Tus Pedidos</span>
          )}
        </Accordion.Header>
          <Accordion.Body className="borders">
          <Row className="g-3">
  {pedidosFiltrados.map((pedido: any) => (
    <Col md={4} key={pedido.pedidoNroMovVta}>
      <Card className="bg-primary text-white h-100">
        <Card.Body className="card-background-color d-flex justify-content-between p-3">
          {/* Columna Icono */}
          <div className="d-flex align-items-center me-3">
            <img
              src={require(`../../assets/img/pedido/${imagenEstadoPedido(pedido?.pedidoEstado?.pedidoEstadoId)}`)}
              alt=""
              width="40"
              height="40"
              className="br-2 icon-pedidos-inicio"
            />
          </div>

          {/* Columna Texto */}
          <div className="d-flex flex-column flex-grow-1 text-right card-text-color me-2" style={{ fontSize: '0.9rem' }}>
            <div className="mb-1">
              <strong>Estado:</strong> <span className="text-uppercase">{pedido.pedidoEstado.pedidoEstadoDescripcion}</span>
            </div>
            <div className="mb-1">
              <strong>NMV:</strong> {pedido.pedidoNroMovVta}
            </div>
            <div className="mb-1">
              <strong>Fecha:</strong> {new Date(pedido.pedidoFecha).toLocaleDateString("es-ES")}
            </div>
            <div className="text-truncate">
              <strong>Transporte:</strong>{" "}
              {(Array.isArray(transportesDisponibles) &&
                transportesDisponibles.find(
                  (transporte) => transporte.transporteID === pedido.transportePedidoID
                )?.transporteNombre) ||
                pedido.transportePedidoID}
            </div>
          </div>

          {/* Columna Botón - Centrado y más grande */}
          {pedido.pedidoEstado.pedidoEstadoId === 10 && (
            <div className="d-flex flex-column justify-content-center align-items-center ms-2" style={{ minWidth: '100px' }}>
              <Button
                variant="primary"
                className="py-2 px-3" // Aumentado el padding vertical/horizontal
                style={{ fontSize: '0.9rem' }} // Tamaño de fuente un poco mayor
                onClick={() => handleRecibirPedido(pedido.pedidoNroMovVta)}
              >
                <strong>Confirmar Recepción</strong>
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>

                </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {/* </Card.Body> */}
    </Card>
  </Col>
{/*)}*/}
    </div>
  );
});

export default ModalPedidoInicio;
